const APP_EVENT_NAME =
  "fitmeup:app-event";

const ONBOARDING_COMMAND_NAME =
  "fitmeup:onboarding-command";

export function emitAppEvent(
  type,
  payload = {}
) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(APP_EVENT_NAME, {
      detail: {
        type,
        payload,
      },
    })
  );
}

export function subscribeAppEvents(
  handler
) {
  if (typeof window === "undefined") {
    return () => {};
  }

  const listener = (event) => {
    handler?.(
      event?.detail || {}
    );
  };

  window.addEventListener(
    APP_EVENT_NAME,
    listener
  );

  return () => {
    window.removeEventListener(
      APP_EVENT_NAME,
      listener
    );
  };
}

export function openOnboardingMenu() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(
      ONBOARDING_COMMAND_NAME,
      {
        detail: {
          command: "start-food",
        },
      }
    )
  );
}

export function subscribeOnboardingCommands(
  handler
) {
  if (typeof window === "undefined") {
    return () => {};
  }

  const listener = (event) => {
    handler?.(
      event?.detail || {}
    );
  };

  window.addEventListener(
    ONBOARDING_COMMAND_NAME,
    listener
  );

  return () => {
    window.removeEventListener(
      ONBOARDING_COMMAND_NAME,
      listener
    );
  };
}